import * as React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { IError } from "../../utils/Api";

const ErrorModal: React.FC<{
  title: string;
  subTitle?: string;
  errors: Array<IError>;
  onClose: () => void;
  customMessage?: string
}> = ({ title, subTitle, errors, onClose, customMessage }) => {
  return (
    <Modal isOpen trapFocus>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <h5>{subTitle}</h5>
        {errors.map((m, idx) => (
          <p key={idx}>
            {customMessage ? customMessage : `Code: ${m.code}, Message: ${m.message}`}
          </p>
        ))}
      </ModalBody>
      <ModalFooter className="text-right">
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ErrorModal;
